// Text labels are anchored by lon/lat, not by the height that happened to be
// under the cursor when they were placed. A label placed with 3D terrain off
// stores an ellipsoid height near zero; with terrain on, the ground at that
// spot can sit hundreds of metres higher, so the stored point is buried and
// slides against the surface as the camera moves. Re-sampling the globe's
// current height every frame keeps the text pinned to whichever surface is
// active, and lets older labels self-correct with no data migration.
//
// Cesium-free core so it can be tested with a stubbed height sampler.
// Returns the stored sample with its height replaced by the sampler's answer.
// A sampler that has no answer yet (terrain tiles still loading) leaves the
// stored height in place rather than snapping the label to the ellipsoid.
export const groundLabelSample = (stored, sampleHeight) => {
    const height = sampleHeight(stored.longitude, stored.latitude);
    if (height === undefined || !Number.isFinite(height))
        return stored;
    if (height === stored.height)
        return stored;
    return { longitude: stored.longitude, latitude: stored.latitude, height };
};
// Minimum pointer travel before a mouse-down on a label becomes a drag.
// Below this a press is a click (select), so a label can never be nudged
// by the act of selecting it.
export const LABEL_DRAG_THRESHOLD_PX = 3;
export const hasCrossedDragThreshold = (start, current, threshold = LABEL_DRAG_THRESHOLD_PX) => {
    const dx = current.x - start.x;
    const dy = current.y - start.y;
    return dx * dx + dy * dy >= threshold * threshold;
};
// A mouse-down on a label's text only becomes a drag when the user has
// shown intent to edit labels: the Label tool is armed, or this label is
// already selected. Otherwise the press belongs to the map (pan).
export const canBeginLabelDrag = (labelId, gate) => {
    if (gate.button !== 0)
        return false;
    if (!gate.inProject)
        return false;
    return gate.labelToolArmed || gate.selectedLabelId === labelId;
};
